export const dateLocale = {
    format: 'DD.MM.YYYY',
    firstDay: 1,
    daysOfWeek: [
        i18next.t('DateInput.locale.format.daysOfWeek.sunday'),
        i18next.t('DateInput.locale.format.daysOfWeek.monday'),
        i18next.t('DateInput.locale.format.daysOfWeek.tuesday'),
        i18next.t('DateInput.locale.format.daysOfWeek.wednesday'),
        i18next.t('DateInput.locale.format.daysOfWeek.thursday'),
        i18next.t('DateInput.locale.format.daysOfWeek.friday'),
        i18next.t('DateInput.locale.format.daysOfWeek.saturday'),
    ],
    monthNames: [
        i18next.t('DateInput.locale.format.monthNames.january'),
        i18next.t('DateInput.locale.format.monthNames.february'),
        i18next.t('DateInput.locale.format.monthNames.march'),
        i18next.t('DateInput.locale.format.monthNames.april'),
        i18next.t('DateInput.locale.format.monthNames.may'),
        i18next.t('DateInput.locale.format.monthNames.june'),
        i18next.t('DateInput.locale.format.monthNames.july'),
        i18next.t('DateInput.locale.format.monthNames.august'),
        i18next.t('DateInput.locale.format.monthNames.september'),
        i18next.t('DateInput.locale.format.monthNames.october'),
        i18next.t('DateInput.locale.format.monthNames.november'),
        i18next.t('DateInput.locale.format.monthNames.december'),
    ],
    cancelLabel: i18next.t('DateInput.locale.format.cancelLabel'),
    applyLabel: i18next.t('DateInput.locale.format.applyLabel'),
};
